import { Radio as NulogyRadio } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

export default function Radio({ labelText, field: name, onChange, value, ...ndsProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = (event) => {
    const { checked } = event.target;
    if (onChange) {
      onChange({ checked, setFieldValue });
    }
    helpers.setValue(value);
  };

  return (
    <NulogyRadio
      checked={field.value === value}
      error={meta.error}
      labelText={labelText}
      onChange={handleChange}
      {...ndsProps}
    />
  );
}
